import { createContext as s, useContext as l, useState as o, useEffect as c, Children as d } from "react";
const g = s({ stagger: !1 }), C = ({ children: t }) => {
  const { stagger: r } = l(g), [e, a] = o(!r);
  return c(() => {
    if (e)
      return;
    const n = requestIdleCallback(() => {
      a(!0);
    });
    return () => cancelIdleCallback(n);
  }, [e]), e ? t : d.toArray(t).slice(0, 3);
};
export {
  g as S,
  C as a
};
//# sourceMappingURL=StaggeredRender-DgsamH_G.js.map
